import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { contactUrls } from '../constants/contactUrls'

export const BacktrackingContext = React.createContext()

export const BacktrackingProvider = ({ children }) => {
  const location = useLocation()
  const [route, setRoute] = useState({
    to: location.pathname,
    from: location.pathname,
    lastContactTabletRoute: '/contacts',
  })

  useEffect(() => {
    const { pathname, search } = location
    const pathnameParts = pathname.split('/').filter(Boolean)

    const isContactsBaseRoute =
      contactUrls.some((url) => location.pathname.includes(url)) && !parseInt(pathnameParts[pathnameParts.length - 1])

    if (isContactsBaseRoute) {
      setRoute((prev) => ({ ...prev, lastContactTabletRoute: `${location.pathname}${search && search}` }))
    }

    //todo handle customers

    setRoute((prev) => ({ ...prev, to: `${location.pathname}${search && search}`, from: `${prev.to}` }))
  }, [location])

  return <BacktrackingContext.Provider value={route}>{children}</BacktrackingContext.Provider>
}
